import React from 'react'
import { Box, IconButton, Menu, MenuItem, Tooltip } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-duotone-svg-icons/faTimes'
import { faSyncAlt } from '@fortawesome/pro-duotone-svg-icons/faSyncAlt'
import { faExpand } from '@fortawesome/pro-duotone-svg-icons/faExpand'
import { faCalendarAlt } from '@fortawesome/pro-duotone-svg-icons/faCalendarAlt'

import BlockEditButton from './BlockEditButton'
import { StyledButton, CompactButton } from '@/shared/ui/buttons'

export default class BlockToolbar extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            dateFormat: null,
            anchorEl: null,
        }
    }

    render() {
        const kedo = this.props.kedo
        const open = Boolean(this.state.anchorEl)

        return (
            <Box
                className={'kedo-block-toolbar'}
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    gap: 0.5,
                }}
            >
                {kedo.isAdminOrEnvironmentAdmin() ? (
                    <BlockEditButton
                        item={this.props.block}
                        kedo={kedo}
                        onSuccess={() =>
                            this.props.onSuccess?.(this.props.block.id)
                        }
                    />
                ) : null}
                {this.props.fetchData ? (
                    <Tooltip title={kedo.t('Refresh')}>
                        <IconButton
                            size="small"
                            className="kedo-block-filter"
                            onClick={() => this.props.fetchData()}
                        >
                            <FontAwesomeIcon icon={faSyncAlt} size="sm" />
                        </IconButton>
                    </Tooltip>
                ) : null}
                {this.props.block &&
                this.props.block.settings?.use_creation_date ? (
                    <>
                        <Tooltip
                            title={kedo.t(
                                this.state.dateFormat ?? 'Date format'
                            )}
                        >
                            <IconButton
                                size="small"
                                id={`block-d-${this.props.block.id}`}
                                className="kedo-block-filter"
                                onClick={(e) =>
                                    this.setState({
                                        anchorEl: e.currentTarget,
                                    })
                                }
                                aria-controls={
                                    open ? 'date-format-menu' : undefined
                                }
                                aria-expanded={open ? 'true' : undefined}
                            >
                                <FontAwesomeIcon
                                    icon={faCalendarAlt}
                                    size="sm"
                                />
                            </IconButton>
                        </Tooltip>
                        <Menu
                            id="date-format-menu"
                            anchorEl={this.state.anchorEl}
                            open={open}
                            onClose={() => this.setState({ anchorEl: null })}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <MenuItem
                                onClick={() =>
                                    this.setState(
                                        {
                                            dateFormat: 'year_month',
                                            anchorEl: null,
                                        },
                                        () =>
                                            this.props.setFilterAndFetchData(
                                                'dateFormat',
                                                'year_month'
                                            )
                                    )
                                }
                            >
                                {kedo.t('year_month')}
                            </MenuItem>
                            <MenuItem
                                onClick={() =>
                                    this.setState(
                                        {
                                            dateFormat: 'quarter',
                                            anchorEl: null,
                                        },
                                        () =>
                                            this.props.setFilterAndFetchData(
                                                'dateFormat',
                                                'quarter'
                                            )
                                    )
                                }
                            >
                                {kedo.t('quarter')}
                            </MenuItem>
                            <MenuItem
                                onClick={() =>
                                    this.setState(
                                        {
                                            dateFormat: 'year',
                                            anchorEl: null,
                                        },
                                        () =>
                                            this.props.setFilterAndFetchData(
                                                'dateFormat',
                                                'year'
                                            )
                                    )
                                }
                            >
                                {kedo.t('year')}
                            </MenuItem>
                        </Menu>
                    </>
                ) : null}
                {this.props.onMax ? (
                    <Tooltip title={kedo.t('Maximize')}>
                        <IconButton
                            size="small"
                            onClick={() =>
                                this.props.onMax(this.props.block.uuid)
                            }
                        >
                            <FontAwesomeIcon icon={faExpand} size="sm" />
                        </IconButton>
                    </Tooltip>
                ) : null}
                <Tooltip title={kedo.t('Hide')}>
                    <IconButton
                        size="small"
                        onClick={() =>
                            this.props.onClose(this.props.block.uuid)
                        }
                    >
                        <FontAwesomeIcon icon={faTimes} size="sm" />
                    </IconButton>
                </Tooltip>
            </Box>
        )
    }
}
